module.exports = __webpack_public_path__ + "img/icon_people.666ae5d3.png";